import { WprBaseObject } from '../../WprBaseObject';
import { WprBaseViewCore } from '../WprBaseViewCore';
import { WprControlConfig } from './WprControlConfig';
import { IWprConfigOption } from './IWprConfigOption';
import { WprControlStatus } from './WprControlStatus';
import { IWprControlState, WprControlVisibility } from '../../component/props/IWprControlState';
import { WprBaseControlComponent } from '../../component/controls/WprBaseControlComponent';
import { WprControlValidator } from '../validation/WprControlValidator';
import { WprInvalidInfo } from '../validation/WprInvalidInfo';
import { WprValidError } from '../validation/WprValidError';
import { WprRowInfo } from '../../component/props/WprRowInfo';
import { WprValidErrorInfo } from '../validation/WprValidErrorInfo';

/**
 * コントロール情報
 */
export class WprControlInfo extends WprBaseObject {
	// static 変数  -------------------------------------------------------------
	public static	isReadonlyRefresh: boolean	= false;		// 読取専用のみ再表示フラグ
	public static	isChangeValue: boolean 		= false;		// 値変更フラグ
	// --------------------------------------------------------------------------

	// private 変数  ------------------------------------------------------------
	private m_Name: string									= null;						// 名称
	private m_Description: string							= null;						// 説明
	private m_Value: any									= '';						// 値
	private m_Dirty: boolean								= false;					// 変更フラグ
	private m_Visibility: boolean							= true;						// 表示状態
	private m_Display: boolean								= true;						// 表示状態
	private m_Tag: any										= null;						// タグ
	private m_Style: object									= null;						// スタイル
	private m_Class: string									= null;						// スタイル
	private m_Placeholder: string							= null;						// placeholder
	private m_ModelName: string								= null;						// モデル名称
	private m_BindName: string								= null;						// モデルにバインドする名称
	private m_ViewCore: WprBaseViewCore						= null;						// ビュー情報
	private m_Config: WprControlConfig						= null;						// コントロール定義情報
	private m_Validator: WprControlValidator				= null;						// バリデータ
	private m_Status: WprControlStatus						= new WprControlStatus();	// コントロールステータス
	private m_SubModelList: string[]						= null;						// サブモデルリスト
	private m_IsDispAuth: boolean 							= true;						// 表示権限
	private m_IsEnableAuth: boolean 						= true;						// 活性化権限
	private m_ConfigModel: string							= null;						// 定義モデル
	private m_isFirst: boolean								= true;						// 初回フラグ
	private m_ComponentList: WprBaseControlComponent<any, any>[]	= new Array();		// コントロールステータス
	private m_InValidList: WprInvalidInfo[]					= null;						// バリデーションエラー情報リスト
	private m_IsInvalid: boolean							= false;					// バリデーションフラグ
	private m_RowIndex: number								= -1;						// 行インデクス
	private m_ValidError: WprValidError						= null;						// バリデーションエラー情報
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** 名称 */
	public get name(): string 					{ return this.m_Name; 			}
	/** 説明 */
	public get description(): string 			{ return this.m_Description; 	}	public set description(desc: string) 			{ this.m_Description = desc;	}
	/** 値 */
	public get value(): any 					{ return this.m_Value;	 		} 	public set value(value: any) 					{ this.setValue(value);			}
	/** 変更フラグ */
	public get dirty(): any 					{ return this.m_Dirty;	 		} 	public set dirty(value: any) 					{ this.setDirty(value);			}
	/** タグ */
	public get tag(): string 					{ return this.m_Tag; 			} 	public set tag(tag: string) 					{ this.m_Tag = tag;				}
	/** スタイル */
	public get style(): object 					{ return this.m_Style; 			} 	public set style(style: object) 				{ this.setStyle(style);			}
	/** クラス */
	public get class(): string 					{ return this.m_Class; 			} 	public set class(cls: string) 					{ this.setClass(cls);			}
	/** placeholder */
	public get placeholder(): any 				{ return this.m_Placeholder;	} 	public set placeholder(placeholder: any) 		{ this.setPlaceholder(placeholder);	}
	/** モデル名称 */
	public get bindName(): string 				{ return this.m_BindName; 		}
	/** モデルにバインドする名称 */
	public get modelName(): string 				{ return this.m_ModelName; 		}
	/**  コントロール定義情報 */
	public get config(): WprControlConfig 		{ return this.m_Config; 		}	public set config(config: WprControlConfig)		{ this.m_Config = config;		}
	/**  バリデータ */
	public get validator(): WprControlValidator { return this.m_Validator; 		}	public set validator(valid: WprControlValidator) { this.m_Validator = valid;	}
	/** コントロールステータス */
	public get status(): WprControlStatus 		{ return this.m_Status; 		}	public set status(status: WprControlStatus)		{ this.m_Status = status;		}
	/** サブモデルリスト */
	public get subModelList(): string[] 		{ return this.m_SubModelList; 	}
	/** 定義モデル */
	public get configModel(): string	 		{ return this.m_ConfigModel; 	}
	/** ビュー情報 */
	public get viewCore(): WprBaseViewCore		{ return this.m_ViewCore; 		}
	/** 行インデクス */
	public get rowIndex(): number				{ return this.m_RowIndex; 		}	public set rowIndex(index: number) 				{ this.m_RowIndex = index;		}
	/** バリデーションエラー情報 */
	public get validError(): WprValidError		{ return this.m_ValidError; 	}	public set validError(error: WprValidError) 	{ this.setErrorInfo(error);		}
	/** バリデーションフラグ */
	public get isInvalid(): boolean				{ return this.m_IsInvalid; 		}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(viewCore: WprBaseViewCore, name: string, description: string, modelName: string, config: IWprConfigOption) {
		super();
		this.m_ViewCore = viewCore;
		this.m_Name = name;
		this.m_Description = description;
		this.m_BindName = name;
		this.setModelName(modelName);
		if (config) {
			this.m_Config = new WprControlConfig(name, this.m_ViewCore, config);
			if (config.bindName)
				this.m_BindName = config.bindName;
			if (config.bindModel === true)
				this.m_BindName = null;
			if (config.hissu)
				this.m_Status.hissu = config.hissu;
			if (config.readOnly)
				this.m_Status.readOnly = config.readOnly;
			if (config.disabled)
				this.m_Status.disabled = config.disabled;
			if (config.min)
				this.m_Status.min = config.min;
			if (config.max)
				this.m_Status.max = config.max;
			if (config.minLength)
				this.m_Status.minLength = config.minLength;
			if (config.maxLength)
				this.m_Status.maxLength = config.maxLength;
			this.m_Validator = new WprControlValidator(this.m_Description, config);
		}
		else {
			this.m_Config = new WprControlConfig(name, this.m_ViewCore);
		}
		this.setDispAuth();
		this.setEnableAuth();
	}
	// --------------------------------------------------------------------------

	// public メソッド  ---------------------------------------------------------
	/**
	 * 入力チェック処理
	 * @param name アクション名又はコントロール名
	 * @param validError 入力エラー情報
	 * @param isControl コントロールチェックフラグ
	 * @param ieEdit 編集フラグ
	 * @returns falseの場合は、エラー
	 */
	public checkValidate(name: string, validError: WprValidError, isControl: boolean, isEdit: boolean): boolean {
		if (this.m_Validator != null) {
			let check = false;
			if (isControl === true) {
				if (name === this.m_Name || name === this.m_Name+'@@blur')
					check = true;
			}
			else if (this.m_Config.actionList == null || this.m_Config.actionList.includes(name) === true) {
				check = true;
			}
			if (check === true) {
				if (this.m_Validator.checkValidate(this, validError) === false) {
					this.m_Status.inputError = true;
					this.validError = validError;
					return false;
				}
				this.m_Status.inputError = false;
				this.validError = null;
			}
			else {
				return true;
			}
		}
		if (isControl === false) {
			this.m_Status.inputError = false;
			if (isEdit === true)
				this.dirty = true;
			this.validError = null;
		}
		else if (isEdit === true)
			this.dirty = true;
		return true;
	}

	/**
	 * コントロールコンポーネント設定
	 * @param componet コントロールコンポーネント
	 */
	public setComponent(componet: WprBaseControlComponent<any, any>): void {
		this.m_ComponentList.push(componet);
	}

	/**
	 * コンポーネントのステータス取得
	 * @param row 行情報
	 * @returns コントロールステータス
	 */
	public getComponentState(row?: WprRowInfo): IWprControlState {
		let visibility = WprControlVisibility.VISIBLE;
		if (this.m_IsDispAuth === false || this.m_Display === false)
			visibility = WprControlVisibility.COLLAPSED;
		else if (this.m_Visibility === false)
			visibility = WprControlVisibility.HIDDEN;
		let cls = null;
		if (this.m_ValidError)
			cls = this.m_Config.errorClass;
		else if (this.m_Dirty === true || this.value)
			cls = this.m_Config.editClass;
		else
			cls = this.m_Config.noEditClass;
		return { 
			value: this.m_Value,
			disabled: this.status.disabled,
			readOnly: this.status.readOnly,
			style: null,
			dirty: this.m_Dirty,
			className: cls,
			min: this.status.min,
			max: this.status.max,
			minLength: this.status.minLength,
			hissu: this.status.hissu,
			maxLength: this.status.maxLength,
			invalid: this.m_IsInvalid,
			visibility: visibility,
			placeholder: null
		};
	}

	public resetPos() {
		this.m_ComponentList.forEach(cinfo => {
			cinfo.resetPos();
		});
	}

	/**
	 * 値変更処理
	 * @param value 値
	 * @returns falseの場合、変更を取り消す
	 */
	public changeValue(value: any): boolean {
		try {
			const bval = this.value;
			this.value = value;
			WprControlInfo.isChangeValue = false;
			if (this.m_ViewCore.onChangeValue(this.m_Name, value) === false) {
				this.value = bval;
				this.resetPos();
				return false;
			}
		}
		catch (ex) {
			this.m_ViewCore.addErrorLog(`onChangeValueで例外が発生しました。[${this.m_Name}][${value}]`, ex);
		}
		this.m_ViewCore.changeValue(this.m_Name, value);
		this.m_ViewCore.viewInfo.checkScopeModelValue();
		this.m_ViewCore.viewInfo.updateComponentMode();
		return true;
	}

	/**
	 * リスト値変更処理
	 * @param value 値
	 * @param row 行データ
	 * @returns falseの場合、変更を取り消す
	 */
	public changeListValue(value: any, row: any): boolean {
		try {
			const bval = this.value;
			this.value = value;
			WprControlInfo.isChangeValue = false;
			if (this.m_ViewCore.onChangeListValue(this.m_Name, row, value) === false) {
				this.value = value;
				this.m_ComponentList.forEach(cinfo => {
					cinfo.resetPos();
				});
				return false;
			}
		}
		catch (ex) {
			this.m_ViewCore.addErrorLog(`changeListValueで例外が発生しました。[${this.m_Name}][${value}]`, ex);
		}
		this.m_ViewCore.changeListValue(this.m_Name, row, value);
		this.m_ViewCore.viewInfo.checkScopeModelValue();
		this.m_ViewCore.viewInfo.updateComponentMode();
		return true;
	}

	/**
	 * 非活性状態設定処理
	 * @param disabled 非活性フラグ
	 */
	public setDisabled(disabled: boolean): void {
		if (this.m_IsEnableAuth === false)
			return;
		if (this.m_Config.enableMode)
			disabled = !this.viewCore.checkMode(this.m_Config.enableMode);
		this.status.disabled = disabled;
		this.m_ComponentList.forEach(cinfo => {
			cinfo.setDisabled(disabled);
		});
	}

	/**
	 * 読取り専用設定処理
	 * @param readOnly 読取り専用フラグ
	 */
	public setReadOnly(readOnly: boolean): void {
		if (this.m_IsEnableAuth === false)
			return;
		this.status.readOnly = readOnly;
		this.m_ComponentList.forEach(cinfo => {
			cinfo.setReadOnly(readOnly);
		});
	}

	/**
	 * 表示状態設定処理
	 * @param display 表示フラグ
	 */
	public setDisplay(display: boolean): void {
		if (this.m_IsDispAuth === false)
			return;
		this.status.display = display;
		if (this.m_Display !== display) {
			this.m_Display = display;
			this.m_ComponentList.forEach(cinfo => {
				cinfo.setVisibility(this.m_Visibility, display);
			});
		}
	}

	/**
	 * 表示状態設定処理
	 * @param visibility 表示フラグ
	 */
	public setVisibility(visibility: boolean): void {
		if (this.m_IsDispAuth === false)
			return;
		this.status.visibility = visibility;
		if (this.m_Visibility !== visibility) {
			this.m_Visibility = visibility;
			this.m_ComponentList.forEach(cinfo => {
				cinfo.setVisibility(visibility, this.m_Display);
			});
		}
	}

	/**
	 * クラス情報設定
	 * @param cls クラス情報
	 */
	public setClass(cls: string): void {
		if (this.m_IsDispAuth === false)
			return;
		this.m_Class = cls;
		this.m_ComponentList.forEach(cinfo => {
			cinfo.setClass(cls);
		});
	}

	/**
	 * スタイル設定
	 * @param style スタイル
	 */
	public setStyle(style: any): void {
		if (this.m_IsDispAuth === false)
			return;
		this.m_Style = style;
		this.m_ComponentList.forEach(cinfo => {
			cinfo.setStyle(style);
		});
	}

	/**
	 * placeholder設定
	 * @param placeholder placeholder値
	 */
	public setPlaceholder(placeholder: string): void {
		if (this.m_IsDispAuth === false)
			return;
		if (this.m_Placeholder !== placeholder) {
			this.m_Placeholder = placeholder;
			this.m_ComponentList.forEach(cinfo => {
				cinfo.setPlaceholder(placeholder);
			});
		}
	}

	/**
	 * 入力エラー設定
	 * @param name コントロール名
	 * @param errmsg エラーメッセージ
	 */
	public setValidError(name: string, errmsg: string) {
		if (this.m_ValidError == null)
			this.m_ValidError = new WprValidError(this.m_ViewCore);
		this.m_Status.inputError = true;
		this.m_ValidError.addErrorInfo(new WprValidErrorInfo(this.name, this.description, this.rowIndex, 'custom', null, errmsg));
		if (!this.m_InValidList)
			this.m_InValidList = new Array();
		this.m_InValidList.push(new WprInvalidInfo(name, null, errmsg));
		/*
		this.m_ComponentList.forEach(cinfo => {
			cinfo.setValue(this.m_Value);
		});
		*/
		this.setInvalid();
		this.m_ComponentList.forEach(cinfo => {
			this.setClassName(cinfo);
		});
	}

	/**
	 * 入力エラークリア処理
	 * @param name コントロール名
	 * @param errmsg エラーメッセージ
	 */
	public clearValidError(name: string, errmsg: string) {
		if (this.m_ValidError != null) {
			if (this.m_ValidError.removeErrorInfo(errmsg) === true)
				this.m_ValidError = null;
		}
		if (this.m_InValidList) {
			let removeList = new Array();
			for(const einfo of this.m_InValidList) {
				if (einfo.errorMessage === errmsg)
					removeList.push(einfo);
			}
			for(const remove of removeList) {
				const idx = this.m_InValidList.indexOf(remove);
				this.m_InValidList.splice(idx, 1);
				if (this.m_InValidList.length === 0)
					this.m_InValidList = null;
			}
			this.setInvalid();
		}
		this.m_ComponentList.forEach(cinfo => {
			this.setClassName(cinfo);
		});
	}

	/**
	 * ValueMapリセット処理
	 */
	public resetValueMap() {
		for(const cinfo of this.m_ComponentList) {
			if (cinfo.hasValueMap === true) {
				const val = this.value;
				if (val === null)
					this.value = '';
				else
					this.value = null;
				this.value = val;
				return;
			}
		}
	}

	/**
	 * 入力チェック処理
	 * @param value 入力値
	 * @returns falseの場合、入力無効
	 */
	public checkInput(value: string): boolean {
		if (this.m_Validator != null)
			return this.m_Validator.checkInput(value);
		return true;
	}

	/**
	 * コンポーネントモード更新処理
	 */
	public updateComponentMode(): void {
		this.setDisabled(this.status.disabled);
	}

	/**
	 * 値クリア処理
	 * @param value クリアに使用する値 
	 */
	public clearValue(value: string = ''): void {
		this.dirty = false;
		this.value = value;
	}

	/**
	 * 強制再表示処理
	 */
	public refresh(): void {
		this.m_ComponentList.forEach(cinfo => {
			if (cinfo.isMount === true)
				cinfo.forceUpdate();
		});
	}
	// --------------------------------------------------------------------------
 
	// private メソッド  ---------------------------------------------------------
	/**
	 * 表示権限設定
	 */
	private setDispAuth() {
		this.setDisplay(true);
		if (this.m_Config.dispAuthList != null) {
			if (this.FW.auth.checkUserAuthority(this.m_Config.dispAuthList) === false)
				this.m_IsDispAuth = false;
			else
				this.m_IsDispAuth = true;
		}
	}

	/**
	 * 活性化権限設定
	 */
	private setEnableAuth() {
		if (this.m_Config.enableAuthList != null) {
			if (this.FW.auth.checkUserAuthority(this.m_Config.enableAuthList) === false)
				this.m_IsEnableAuth = false;
			else
				this.m_IsEnableAuth = true;
		}
	}

	/**
	 * 値設定処理
	 * @param value 値
	 */
	private setValue(value: any): void {
		if (this.m_Value !== value) {
			this.m_Value = value;
			this.validValue();
			this.m_ComponentList.forEach(cinfo => {
				if (WprControlInfo.isReadonlyRefresh === true || WprControlInfo.isChangeValue === false || cinfo.isEdit === true) {
					if (WprControlInfo.isReadonlyRefresh === false || cinfo.isEdit === false) {
						cinfo.setValue(value);
						this.setClassName(cinfo);
					}
				}
			});
		}
		else {
			this.m_ComponentList.forEach(cinfo => {
				if (WprControlInfo.isReadonlyRefresh === true || WprControlInfo.isChangeValue === false || cinfo.isEdit === true) {
					if (WprControlInfo.isReadonlyRefresh === false || cinfo.isEdit === false)
						cinfo.updateValue(value);
				}
			});
		}
	}

	/**
	 * 変更フラグ設定処理
	 * @param dirty 値
	 */
	private setDirty(dirty: boolean): void {
		if (this.m_Dirty !== dirty) {
			this.m_Dirty = dirty;
			this.validValue();
			this.m_ComponentList.forEach(cinfo => {
				cinfo.setDirty(dirty);
				this.setClassName(cinfo);
			});
		}
	}

	/**
	 * 読取専用フラグ取得
	 * @returns 読取専用フラグ
	 */
	public isReadOnly(): boolean {
		for(const cinfo of this.m_ComponentList) {
			if (cinfo.isEdit === true)
				return false;
		}
		return true;
	}

	/**
	 * モデル名設定処理
	 * @param modelName モデル名
	 */
	private setModelName(modelName: string): void {
		if (modelName) {
			if (modelName.includes('.') === false) {
				this.m_ModelName = modelName;
				this.m_ConfigModel = modelName;
			}
			else {
				modelName.split('.').forEach(model => {
					if (this.m_ModelName == null) {
						this.m_ModelName = model;
						this.m_ConfigModel = model;
					}
					else {
						if (this.m_SubModelList == null)
							this.m_SubModelList = new Array();
						this.m_SubModelList.push(model);
						this.m_ConfigModel += '.' + model;
					}
				});
			}
		}
	}

	/**
	 * バリデーション処理
	 */
	private validValue(): void {
		if (this.m_Validator != null && this.m_Dirty === true)
			this.m_InValidList = this.m_Validator.checkValue(this.m_Value);
		else
			this.m_InValidList = null;
		this.setInvalid();
	}
	
	/**
	 * バリデーションエラー設定
	 */
	private setInvalid(): void {
		let invalid = false;
		if (this.m_InValidList != null)
			invalid = true;
		if (this.m_IsInvalid != invalid) {
			this.m_IsInvalid = invalid;
			this.m_ComponentList.forEach(cinfo => {
				cinfo.setInvalid(invalid);
			});
		}
	}

	/**
	 * エラー情報設定
	 * @param error エラー情報
	 */
	private setErrorInfo(error: WprValidError): void {
		this.m_ValidError = error;
		this.m_ComponentList.forEach(cinfo => {
			this.setClassName(cinfo);
		});
	}

	/**
	 * クラス名設定
	 * @param cinfo コンポーネント情報 
	 */
	private setClassName(cinfo: WprBaseControlComponent<any, any>): void {
		if (this.m_ValidError)
			cinfo.setClass(this.m_Config.errorClass);
		else if (this.m_Dirty === true || this.value)
			cinfo.setClass(this.m_Config.editClass);
		else
			cinfo.setClass(this.m_Config.noEditClass);
	}
	// --------------------------------------------------------------------------
}